import * as types from '../actions/types';
import initialState from './initialState';
import *  as utils from '../utils';


export default function estimateReducer(state = initialState.estimates, action) {

	switch (action.type) {
	
		case types.SAVE_VALUES_SUCCESS:
	
			let output = utils.objectMap(state, (value, key) => {
				if(key === action.estimate.id)
					return undefined;
			
				return [...value];	
			});

			if(output[action.estimate.id] === undefined) 
				output[action.estimate.id] = [...action.estimate.value.map((val) =>{
					return {errors: val.errors,
								selectedValue: val.selectedValue,
								selectedValues: [...val.selectedValues],
								selectedSliderIndex: val.selectedSliderIndex,
								selectedGridIndex: val.selectedGridIndex,
								visited: val.visited}
				})];
		
			 return output;
	
		case types.RESET_CALCULATOR_SUCCESS:
			return Object.assign({}, initialState.estimates);
		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/estimateReducer.js